/**
 * App-wide jurisdiction, sourced from the SafeCurves metadata summary table's
 * `jurisdiction` field (e.g. 'Australia', 'USA'); until that read resolves it
 * is DEFAULT_JURISDICTION. Selects the sign standard used for the map sprite
 * (see `loadMapSprites.ts` in the app directory).
 */

export type Jurisdiction = 'AUS' | 'USA';

const DEFAULT_JURISDICTION: Jurisdiction = 'USA';

export type DrivingSide = 'left' | 'right';

const DEFAULT_SIDE: DrivingSide = 'right';

// Metadata `jurisdiction` values (lower-cased) mapped to sign-standard codes.
const jurisdictionsByName: Record<string, Jurisdiction> = {
	australia: 'AUS',
	usa: 'USA'
};

const drivingSideByJurisdiction: Record<Jurisdiction, DrivingSide> = {
	AUS: 'left',
	USA: 'right'
};

function createJurisdictionStore() {
	let jurisdiction = $state<Jurisdiction>(DEFAULT_JURISDICTION);
	let drivingSide = $state<DrivingSide>(DEFAULT_SIDE);
	return {
		get jurisdiction(): Jurisdiction {
			return jurisdiction;
		},
		get drivingSide(): DrivingSide {
			return drivingSide;
		},
		/** Applies the metadata table's jurisdiction name; unrecognised values leave the default in place. */
		setFromMetadata(row: { jurisdiction?: string | number | null }) {
			if (row.jurisdiction == null) return;
			const match = jurisdictionsByName[String(row.jurisdiction).trim().toLowerCase()];
			if (match) {
				jurisdiction = match;
				drivingSide = drivingSideByJurisdiction[match];
			}
		}
	};
}

export const jurisdictionStore = createJurisdictionStore();
